import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as GarageInvoiceActions from './garage-invoice.action';
import * as SpecificationActions from '../specification/specification.action';
import { GarageInvoiceService } from './garage-invoice.service';
import { SpecificationService } from '../specification/specification.service';

import { BannerService } from '../../shared/services/banner.service';
import * as GarageInvoiceModels from '../../models/garage-invoice/garage-invoice';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import * as Models from '../../models/commonModels';
import { HttpEventType } from '@angular/common/http';
import * as SpecificationListModels from '../../models/specification/specification';
import { SpecificationSearchModel } from '../../models/specification/specificationSearch';

import { saveAs } from 'file-saver';

export interface GarageInvoiceStateModel {
    List: GarageInvoiceModels.GarageInvoiceListModel;
    Search: GarageInvoiceModels.GarageInvoiceSearchModel;
    Save: Models.SaveState;
    LinkedSpecifications: GarageInvoiceModels.LinkedSpecificationListModel;
    PrintData: GarageInvoiceModels.PrintDataListModel;
    SpecificationList: SpecificationListModels.SpecificationListModel;
    SpecificationListLoading: boolean;
    GarageInvoice: GarageInvoiceModels.GarageInvoiceModel;
    Request: Models.RequestBase;
  }

@State<GarageInvoiceStateModel>({
    name: 'garageInvoiceState',
    defaults: {
      List: null,
      Search: new GarageInvoiceModels.GarageInvoiceSearchModel(),
      Save: null,
      LinkedSpecifications: null,
      PrintData: null,
      // lista specyfikacji dodawanych do FV
      SpecificationList: new SpecificationListModels.SpecificationListModel(),

      GarageInvoice: null,
      SpecificationListLoading: false,
      Request: null
    }
  })

  @Injectable()

  export class GarageInvoiceState {

    constructor(
      private helperService: HelperService,
      private garageInvoiceService: GarageInvoiceService,
      private specificationService: SpecificationService,
      private bannerService: BannerService
  ) { }

  @Selector()
  static GarageInvoiceSpecificationListLoading(state: GarageInvoiceStateModel) {
    return state.SpecificationListLoading;
  }

  @Selector()
  static GarageInvoice(state: GarageInvoiceStateModel) {
    return state.GarageInvoice;
  }

  @Selector()
  static List(state: GarageInvoiceStateModel) {
    return state.List;
  }

  @Selector()
  static SpecificationList(state: GarageInvoiceStateModel) {
    return state.LinkedSpecifications;
  }

  @Selector()
  static Save(state: GarageInvoiceStateModel) {
    return state.Save;
  }

  @Selector()
  static GarageInvoiceSearch(state: GarageInvoiceStateModel) {
    return state.Search;
  }

  @Selector()
  static GarageInvoicePrintData(state: GarageInvoiceStateModel) {
    return state.PrintData;
  }

  @Selector()
  static GarageSpecificationList(state: GarageInvoiceStateModel) {
    return state.SpecificationList;
  }

  @Selector()
  static Request(state: GarageInvoiceStateModel) {
    return state.Request;
  }

  @Action(GarageInvoiceActions.GetList)
  GetList(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania listy faktur od serwisów.';

    context.setState(
      patch({
        List: null
      })
    );

    this.garageInvoiceService.get(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            List: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('GarageInvoiceActions.GetList', error);

        this.bannerService.error(errorMessage);
      });

  }

  @Action(GarageInvoiceActions.SetSearch)
  SetSearch(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions .SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new GarageInvoiceActions.GetList(action.Search));
  }

  @Action(GarageInvoiceActions.SetListPage)
  SetListPage(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions .SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new GarageInvoiceActions.GetList(action.Search));
  }

  @Action(GarageInvoiceActions.ResetSearch)
  ResetSearch(
    context: StateContext<GarageInvoiceStateModel>
  ) {

    const state = context.getState();

    const search = new GarageInvoiceModels.GarageInvoiceSearchModel();

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new GarageInvoiceActions.GetList(search));
  }

  @Action(GarageInvoiceActions.Delete)
  Delete(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.Delete
  ) {

    {
      const errorMessage = 'Błąd usuwania FV od serwisu.';
      this.garageInvoiceService.delete(action.GarageInvoiceId).subscribe(
        ret => {
          this.bannerService.success(`Faktura została usunięta (${ret}). `);

          context.setState(
            patch({
              Save: new Models.SaveState(action.GarageInvoiceId, true, action.Version)
            })
          );

          context.dispatch(new GarageInvoiceActions.GetList(context.getState().Search));

        },

        (error) => {
          context.setState(
            patch({
              Save: new Models.SaveState(action.GarageInvoiceId, false, action.Version)
            })
          );

          this.helperService.SaveException('GarageActions.Set', error);
          this.bannerService.error(errorMessage);
        },
        () => { });
      }
  }


  @Action(GarageInvoiceActions.GetLinkedSpecifications)
  GetLinkedSpecifications(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.GetLinkedSpecifications
  ) {

    const errorMessage = 'Błąd pobierania listy powiązanych specyfikacji.';

    context.setState(
      patch({
        LinkedSpecifications: null
      })
    );

    this.garageInvoiceService.getLinkedSpecifications(action.GarageInvoiceId).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            LinkedSpecifications: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('GarageInvoiceActions.GetLinkedSpecifications', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(GarageInvoiceActions.ResetSpecificationList)
  ResetSpecificationList(
    context: StateContext<GarageInvoiceStateModel>
  ) {

    const state = context.getState();

    context.setState(
      patch({
        LinkedSpecifications: null,
        SpecificationList: new SpecificationListModels.SpecificationListModel()
      })
    );

  }

  @Action(GarageInvoiceActions.Insert)
  insert(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.Insert
  ) {
    const errorMessage = 'Błąd utworzenia nowego dokumentu.';

    this.garageInvoiceService.insert(action.Invoice).subscribe(
      ret => {
        if (ret.type === HttpEventType.Response && ret.status === 200) {
          action.Invoice.GarageInvoiceId = Number(ret.body);
          this.bannerService.success(`Utworzono nowy dokument .`);
        }

        context.setState(
          patch({
            Save: new Models.SaveState(action.Invoice.GarageInvoiceId, true, action.Version)
          })
        );
      },

      (error) => {

        context.setState(
          patch({
            Save: new Models.SaveState(action.Invoice.GarageInvoiceId, false, action.Version)
          })
        );

        this.helperService.SaveException('GarageInvoiceActions.Insert', error);
        this.bannerService.error(errorMessage);
      },
      () => { });
  }


  @Action(GarageInvoiceActions.GetPrintData)
  getPrintData(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.GetPrintData
  ) {

    const errorMessage = 'Błąd pobierania wydruku.';

    context.setState(
      patch({
        PrintData: null
      })
    );

    this.garageInvoiceService.getPrintData(action.GarageInvoiceId).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            PrintData: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('GarageInvoiceActions.GetPrintData', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(GarageInvoiceActions.GetCompactPrintData)
  getCompactPrintData(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.GetCompactPrintData
  ) {

    const errorMessage = 'Błąd pobierania wydruku uproszczonego.';

    context.setState(
      patch({
        PrintData: null
      })
    );

    this.garageInvoiceService.getCompactPrintData(action.GarageInvoiceId).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            PrintData: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('GarageInvoiceActions.GetCompactPrintData', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(GarageInvoiceActions.AddSpecification)
  addSpecification(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.AddSpecification
  ) {
    const state = context.getState();

    const errorMessage = 'Błąd dodawania specyfikacji .';
    const list = state.SpecificationList;
    list.Items.push(action.Specification);

    context.setState(
      patch({
        SpecificationList: new SpecificationListModels.SpecificationListModel(list.Items, -1)
      })
    );

  }

  @Action(GarageInvoiceActions.AddSelectedSpecificationList)
  addSelectedSpecificationList(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.AddSelectedSpecificationList
  ) {
    const state = context.getState();

    action.Specifications.forEach((specification) => {
      if (specification.Hide === undefined || specification.Hide === false) {
        context.dispatch(new GarageInvoiceActions.AddSpecification(specification));
      }
    });

  }

  @Action(GarageInvoiceActions.RemoveListItem)
  removeItemFromList(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.RemoveListItem
  ) {

    const state = context.getState();
    state.SpecificationList.Items.find( (element, index) => {
      if (element.SpecificationId === action.SpecificationId ) {
        state.SpecificationList.Items.splice(index, 1);
        context.dispatch(new SpecificationActions.ShowListItem(action.SpecificationId));

        context.setState(
          patch({
            SpecificationList: new SpecificationListModels.SpecificationListModel(state.SpecificationList.Items, -1)
          })
        );

        return;
      }
    });

  }

  @Action(GarageInvoiceActions.RemoveAllListItem)
  removeAllListItem(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.RemoveAllListItem
  ) {

    const state = context.getState();
    context.dispatch(new SpecificationActions.ShowAllListItem());

    context.setState(
          patch({
            SpecificationList: new SpecificationListModels.SpecificationListModel()
          })
    );

  }

  @Action(GarageInvoiceActions.SetGarageInvoice)
  SetGarageInvoice(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.SetGarageInvoice
  ) {

    const state = context.getState();

    context.setState(
          patch({
            GarageInvoice: new GarageInvoiceModels.GarageInvoiceModel(action.GarageInvoice.GarageId)
          })
    );

  }

  @Action(GarageInvoiceActions.GetGarageInvoice)
  getGarageInvoice(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.SetGarageInvoice
  ) {

    const state = context.getState();

    context.setState(
          patch({
            GarageInvoice: state.GarageInvoice
          })
    );

  }

  @Action(GarageInvoiceActions.AddFilteredSpecifications)
  addFilteredSpecifications(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.AddFilteredSpecifications
  ) {
    function patchContext(list: SpecificationListModels.SpecificationListModel , loading: boolean) {
      context.setState(
        patch({
          SpecificationList: list,
          SpecificationListLoading: loading
        })
      );
     }

    action.Search.CurrentPage = 1;
    const state = context.getState();
    const errorMessage = 'Błąd pobierania listy wyfiltrowanych specyfikacji dla nowej FV.';
    const tmpSearch = Object.assign(new SpecificationSearchModel(), action.Search);
    tmpSearch.IsPagination = false;

    patchContext(new SpecificationListModels.SpecificationListModel(), true);

    this.specificationService.getList(tmpSearch).subscribe((ret) => {
      if (ret.Success) {
        patchContext(ret, false);

        return ret;
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('GarageInvoiceActions.AddFilteredSpecifications', error);

        this.bannerService.error(errorMessage);
      });

  }

  @Action(GarageInvoiceActions.CorrectionRequest)
  correctionRequest(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.CorrectionRequest
  ) {
    const errorMessage = 'Błąd wysyłania żadania korekty';
    this.garageInvoiceService.correctionRequest(action.Request).subscribe((ret) => {
      this.bannerService.success('Wiadmość email została wysłana.');
    },
      (error) => {
        this.helperService.SaveException('GarageInvoiceActions.CorrectionRequest', error);

        this.bannerService.error(errorMessage);
      });

  }

  @Action(GarageInvoiceActions.DisposeSearch)
  disposeSearch(
      context: StateContext<GarageInvoiceStateModel>
    ) {

      context.setState(
        patch({
          Search: null
        }));
  }

  @Action(GarageInvoiceActions.GetGarageInvoiceReport)
  getDepositeReport(
    context: StateContext<GarageInvoiceStateModel>,
    action: GarageInvoiceActions.GetGarageInvoiceReport
  ) {


    let request: Models.RequestBase = new Models.RequestBase();

    request.RequestSignature = action.Request.RequestSignature;

    this.bannerService.quickInfo('Rozpoczęto generowanie raportu, proszę czekać.');

    this.garageInvoiceService.getReport(action.Request.Item).subscribe(ret => {
      const file = new File([ret], `Faktury-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(file);
    },
      (error) => {

        this.helperService.SaveException('GarageInvoiceActions.GetGarageInvoiceReport', error);

        this.bannerService.error('Błąd pobierania raportu faktur.');
      },
      () => {

        context.setState(
          patch({
            Request: request
          })
        );
      }
    );
  }
}

